var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LazyHydrate',{attrs:{"never":""}},[(_vm.content)?_c('article',{staticClass:"article-block"},[_c('h2',{staticClass:"detail-infos__subheading--label"},[_vm._t("default")],2),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }